import classNames from "classnames";
import type { ComponentProps } from "react";
import styles from "./radio.module.css";

export type RadioProps = ComponentProps<"span"> & {
  isSelected: boolean;
};

export function Radio({
  isSelected,
  className,
  children,
  ...props
}: RadioProps) {
  return (
    <span
      className={classNames([styles.Radio, className])}
      role="img"
      aria-hidden
      {...props}
    >
      <span
        className={styles.RadioCircle}
        data-checked={isSelected}
        aria-hidden
      />
      <span className={styles.RadioLabel}>{children}</span>
    </span>
  );
}
